import { PropsWithChildren } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { MenuLayout, MenuLayoutMobile } from "src/widgets";

export const AdminLayout = ({ children }: PropsWithChildren) => {
  const { isMobile } = useGravityDevice();
  const Layout = isMobile ? MenuLayoutMobile : MenuLayout;

  return <Layout>{children}</Layout>;
};
